module.exports = __webpack_public_path__ + "static/media/experience_image_2@2x.bb7f60c6.png";